// @ts-strict-ignore
import React from "react";
import { useMedia } from "react-use";
import { withTheme } from "styled-components";
import { Text, mediaQuery } from "@hubble/web";
import type { AppTheme } from "themes/global";
import type { BodyTextSize } from "@hubble/web/dist/esm/components/Text/BodyText";
import Link from "components/parts/NextLink";
import { RiskBannerContentWrapper, RiskBannerWrapper } from "../Wrappers";
import { useCoinDetails } from "components/layout/providers/CoinDetails";
import storage from "config/storage";
import { getCoinType } from "utils/coins";

const UK_RISK_PAGE_ROUTE = "/uk-fca-risks";

type UKRiskBannerProps = {
  id?: string;
  theme?: AppTheme;
};

const UKRiskBanner = ({ id, theme }: UKRiskBannerProps) => {
  const coinDetails = useCoinDetails();
  const isMobileScreen = useMedia(mediaQuery.mobileXsDown, false);
  const [showWarning, setShowWarning] = React.useState(false);

  const riskStyleMobileProps = isMobileScreen
    ? {
        size: "sm" as BodyTextSize,
        lineHeight: "17px"
      }
    : { size: "sm" as BodyTextSize };

  const dismissRiskWarning = () => {
    storage.set("ukFCARiskWarningDismissed", true, "sessionStorage");
    setShowWarning(false);
  };

  React.useEffect(() => {
    const hasWarningDismissed = storage.get(
      "ukFCARiskWarningDismissed",
      "sessionStorage"
    );
    if (!hasWarningDismissed) {
      setShowWarning(true);
    }
  }, []);

  const assetType = coinDetails ? getCoinType(coinDetails) : undefined;

  return (
    <RiskBannerWrapper id={id}>
      <RiskBannerContentWrapper>
        <Text.Body marketing {...riskStyleMobileProps}>
          Don’t invest unless you’re prepared to lose all the money you invest.
          This is a high-risk investment and you should not expect to be
          protected if something goes wrong. {isMobileScreen && <br />}
          <Text.Link
            bold
            as={Link}
            href={`${UK_RISK_PAGE_ROUTE}${assetType ? `?assetType=${assetType}` : ""}`}
          >
            Take 2 mins to learn more
          </Text.Link>
        </Text.Body>
      </RiskBannerContentWrapper>
      {showWarning && (
        <div className="flex justify-center bg-[rgb(230,230,230)] px-4 py-2">
          <Text.Body size="xs" color={theme?.colorPalette?.gray?.[600]}>
            Please note: Gemini Derivatives and the Gemini Credit Card are not
            available for UK customers.{" "}
            <Text.Link
              color={theme?.textColors?.secondary}
              role="button"
              onClick={dismissRiskWarning}
            >
              Dismiss
            </Text.Link>
          </Text.Body>
        </div>
      )}
    </RiskBannerWrapper>
  );
};

export default withTheme(UKRiskBanner);
